import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { useTheme } from '../../context/ThemeContext'
import { isElectron } from '../../utils/electron'
import './Header.css'

// Admin UID
const ADMIN_UID = 'bdvqas1HoJP7Q4gop9mHqyvNtbu2'

function Header() {
  const { user, logout, isAuthenticated } = useAuth()
  const { isDark, toggleTheme } = useTheme()
  const location = useLocation()

  const navItems = [
    { path: '/', label: 'Inicio', icon: '🏠' },
    { path: '/search', label: 'Buscar', icon: '🔍' },
    { path: '/live', label: 'TV', icon: '📺' },
    { path: '/history', label: 'Historial', icon: '📋' },
    { path: '/watchlist', label: 'Ver después', icon: '🎯' },
    { path: '/friends', label: 'Amigos', icon: '👥' },
  ]

  const isActive = (path) => location.pathname === path
  // Hide admin in Electron desktop app
  const isAdmin = user?.uid === ADMIN_UID && !isElectron()

  if (!isAuthenticated) {
    return (
      <header className="header">
        <div className="container header-container">
          <Link to="/" className="logo">
            <span className="logo-icon">🎬</span>
            <span className="logo-text">Pedrazo Movie Tracker</span>
          </Link>
          <button className="btn btn-ghost" onClick={toggleTheme}>
            {isDark ? '☀️' : '🌙'}
          </button>
        </div>
      </header>
    )
  }

  return (
    <header className="header">
      <div className="container header-container">
        <Link to="/" className="logo">
          <span className="logo-icon">🎬</span>
          <span className="logo-text hide-mobile">Pedrazo Movie Tracker</span>
        </Link>

        <nav className="nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${isActive(item.path) ? 'active' : ''}`}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label hide-mobile">{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="header-actions">
          <button className="btn btn-icon btn-ghost" onClick={toggleTheme}>
            {isDark ? '☀️' : '🌙'}
          </button>

          <div className="user-menu">
            <Link to="/profile" className="user-avatar-link">
              {user?.photoURL ? (
                <img src={user.photoURL} alt={user.displayName} className="avatar" />
              ) : (
                <div className="avatar avatar-placeholder">
                  {user?.displayName?.charAt(0) || '?'}
                </div>
              )}
            </Link>

            <div className="user-dropdown">
              <div className="user-info">
                <span className="user-name">{user?.displayName}</span>
                <span className="user-email">{user?.email}</span>
              </div>
              <hr className="dropdown-divider" />
              <Link to="/profile" className="dropdown-item">
                👤 Mi perfil
              </Link>
              {isAdmin && (
                <Link to="/admin/requests" className="dropdown-item">
                  📋 Requests
                </Link>
              )}
              {isAdmin && (
                <Link to="/admin/iptv" className="dropdown-item">
                  📺 IPTV Lists
                </Link>
              )}
              {!isElectron() && (
                <Link to="/download" className="dropdown-item">
                  💻 Descargar App
                </Link>
              )}
              <button className="dropdown-item" onClick={logout}>
                🚪 Cerrar sesión
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
